import { makeAutoObservable } from "mobx";
import { DataTableStore } from "./DataTableStore";
import { onError } from "@/utils/onError";
import { FiltersStore } from "./FiltersStore";
import { SearchFilter } from "@/components/filters";
export class TechniciansStore {
    constructor(technicianService) {
        this.technicianService = technicianService;
        this.loading = false;
        this.initializeTechnicianFilters = () => {
            const filterItems = [
                // Search Filter
                {
                    id: "search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Поиск по имени, email, телефону...",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.filtersStore.updateFilter("search", value),
                    },
                    visible: true,
                    order: 4,
                },
            ];
            this.filtersStore.setFilterItems(filterItems);
        };
        this.dataTable = new DataTableStore({
            defaultFilters: { search: "" },
            dataLoader: {
                loadData: (params) => this.loadTechnicians(params),
            },
        });
        this.filtersStore = new FiltersStore();
        this.initializeTechnicianFilters();
        makeAutoObservable(this);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async loadTechnicians(params) {
        try {
            // Получаем данные через сервис с учетом параметров
            const result = await this.technicianService.getTechniciansWithParams({
                page: params.page,
                pageSize: params.pageSize,
                filters: params.filters,
                sorters: params.sorters,
            });
            return {
                data: result.data,
                total: result.total,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            throw error;
        }
    }
    async deleteTechnician(id) {
        this.setLoading(true);
        try {
            await this.technicianService.deleteTechnician(id);
            await this.dataTable.refresh();
        }
        catch (error) {
            onError(error, "Error deleting technician");
        }
        finally {
            this.setLoading(false);
        }
    }
}
